import * as React from "react";

import { ResultTableRow } from "./result-table-row";
import { isDefined } from "../../../../../../../lib/data";
import { SellPotentialValue } from "../../../../simulation/result/result-table";

type Props = {
	sellPotentials: SellPotentialValue[];
	goalSalesVolume: number;
};

export const ResultTable = React.memo((props: Props) => {
	const { sellPotentials, goalSalesVolume } = props;
	const initValues = React.useMemo(() => sellPotentials[0].sellPotential, [sellPotentials]);
	const cpValues = React.useMemo(() => sellPotentials[1].sellPotential, [sellPotentials]);
	const testValues = React.useMemo(() => sellPotentials[2].sellPotential, [sellPotentials]);
	return (
		<table className={"result-table"}>
			<thead>
				<tr>
					<th rowSpan={2} className="subtitle">
						推定値
					</th>
					<th rowSpan={2}>初期値(万個)</th>
					<th colSpan={2}>①実績値 修正後</th>
					<th colSpan={2}>②テスト品 変数補整後</th>
				</tr>
				<tr>
					<th>補整値(万個)</th>
					<th>補整率(%)</th>
					<th>補整値(万個)</th>
					<th>補整率(%)</th>
				</tr>
			</thead>
			<tbody>
				<ResultTableRow
					name={"trial"}
					label={"トライアル"}
					initValue={initValues.trial}
					cpValue={cpValues.trial}
					testValue={testValues.trial}
				/>
				<ResultTableRow
					name={"repeat"}
					label={"リピート"}
					initValue={initValues.repeat}
					testValue={testValues.repeat}
					cpValue={cpValues.repeat}
				/>
				<ResultTableRow
					name={"localOther"}
					label={"ローカルその他"}
					initValue={initValues.localOther}
					testValue={testValues.localOther}
					cpValue={cpValues.localOther}
				/>
				<ResultTableRow
					name={"inbound"}
					label={"インバウンド"}
					initValue={initValues.inbound}
					testValue={testValues.inbound}
					cpValue={cpValues.inbound}
				/>
				<ResultTableRow
					name={"total"}
					label={"合計"}
					initValue={initValues.total}
					testValue={testValues.total}
					cpValue={cpValues.total}
				/>
				<ResultTableRow
					name={"goal"}
					label={"目標対比(%)"}
					initValue={(initValues.total / goalSalesVolume) * 100 - 100}
					testValue={isDefined(testValues.total) ? (testValues.total / goalSalesVolume) * 100 - 100 : undefined}
					cpValue={isDefined(cpValues.total) ? (cpValues.total / goalSalesVolume) * 100 - 100 : undefined}
				/>
			</tbody>
		</table>
	);
});
